// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZhKA0","placeholdersHeader":"styles_placeholdersHeader__39LWg","editorStyle":"styles_editorStyle__cbdoq","placeholdersBox":"styles_placeholdersBox__2Wbqz"};